import {
  faCheck,
  faInfoCircle,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Question from './Question'
import InputCheckbox from './Inputs/InputCheckBox'
import InputRadio from './Inputs/InputRadio'
import GridQuestions from '../Course/components/GridQuestions'

const Submission = (props) => {
  let language = props.language || {}
  const currentCourse = props.userProgress.find(
    (item) => item.course_id === props.course_id
  )
  let currentCourseStatus = null
  if (currentCourse) {
    currentCourseStatus = currentCourse.status
  }
  const { questions, submissions } = props

  return (
    <div className='row'>
      {submissions && submissions.length
        ? submissions.map((question, index) => (
            <Question
              {...question}
              isSubmission={props.isSubmission}
              quizPassed={props.quizPassed}
              key={index}
              language={props.language}
            >
              {(() => {
                return (question.options || []).map((optionItem, optionIndex) =>
                  question.type !== 5 && question.type !== 8 ? (
                    <div
                      key={`${question.id}-${optionIndex}`}
                      className='question-row'
                    >
                      {question.type === 3 ? (
                        <InputCheckbox
                          {...props}
                          question={question}
                          item={optionItem}
                          index={optionIndex}
                          disabled
                        />
                      ) : question.type === 4 ? null : (
                        <InputRadio
                          {...props}
                          question={question}
                          item={optionItem}
                          index={optionIndex}
                          disabled
                        />
                      )}
                      {question.type !== 5 ? (
                        question.type === 6 ? (
                          <span className='image-option-wrapper'>
                            <img
                              className={`submitted-image-option ${
                                optionItem.selected
                                  ? 'image-option-selected'
                                  : ''
                              }`}
                              src={`${optionItem.url ? optionItem.url : ''}`}
                            />
                          </span>
                        ) : question.type === 1 ? (
                          <label htmlFor={optionItem.id}>
                            {optionItem.value === 1
                              ? language.courses
                                ? language.courses.true
                                : null
                              : language.courses
                              ? language.courses.false
                              : null}
                          </label>
                        ) : (
                          <label htmlFor={optionItem.id}>
                            {optionItem.name}
                          </label>
                        )
                      ) : null}
                      {(() => {
                        if (!props.quizPassed) {
                          if (
                            question.type === 1 ||
                            question.type === 2 ||
                            question.type === 6
                          ) {
                            if (
                              optionItem.selected === true &&
                              optionItem.id == question.correct_answer
                            ) {
                              return (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  size='md'
                                  className='icon-answ-correct'
                                />
                              )
                            } else if (optionItem.selected) {
                              return (
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className='icon-answ-incorrect'
                                />
                              )
                            }
                          } else if (question.type === 3) {
                            if (
                              optionItem.selected &&
                              optionItem.id === optionItem.correct_answer
                            ) {
                              return (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  size='md'
                                  className='icon-answ-correct'
                                />
                              )
                            } else if (optionItem.selected) {
                              return (
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  size='md'
                                  className='icon-answ-incorrect'
                                />
                              )
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (question.type === 1 && props.quizPassed) {
                          if (props.quizPassed === -1) {
                            if (question.answered && optionItem.selected) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (question.answered) {
                              if (question.answeredCorrect) {
                                if (optionItem.correct) {
                                  return (
                                    <FontAwesomeIcon
                                      icon={faCheck}
                                      size='md'
                                      className='icon-answ-correct'
                                    />
                                  )
                                }
                              } else if (
                                optionItem.correct &&
                                !optionItem.selected
                              ) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    size='md'
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (
                          question.type === 2 ||
                          (question.type === 6 && props.quizPassed)
                        ) {
                          if (props.quizPassed === -1) {
                            if (question.answered && optionItem.selected) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    size='md'
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (question.answered) {
                              if (question.answeredCorrect) {
                                if (optionItem.correct) {
                                  return (
                                    <FontAwesomeIcon
                                      icon={faCheck}
                                      size='md'
                                      className='icon-answ-correct'
                                    />
                                  )
                                }
                              } else if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else if (
                                !optionItem.correct &&
                                optionItem.selected
                              ) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    size='md'
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (question.type === 3 && props.quizPassed) {
                          if (props.quizPassed === -1) {
                            if (optionItem.answered) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    size='md'
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (!optionItem.answered) {
                              if (optionItem.correct) {
                                return (
                                  <span>
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      size='md'
                                      className='icon-answ-incorrect'
                                    />
                                    <label className='hint-text'>
                                      {language.general
                                        ? language.general.not_selected
                                        : null}
                                    </label>
                                  </span>
                                )
                              }
                            } else {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faCheck}
                                    size='md'
                                    className='icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    size='md'
                                    className='icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {question.type === 4 ? (
                        question.correctAnswer &&
                        optionItem.id ===
                          question.correctAnswer[optionIndex].id ? (
                          <FontAwesomeIcon
                            icon={faCheck}
                            size='md'
                            className='icon-answ-correct'
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faTimes}
                            size='md'
                            className='icon-answ-incorrect'
                          />
                        )
                      ) : null}

                      {[1, 2].includes(question.type) &&
                      question.answered &&
                      optionItem.selected &&
                      optionItem.description &&
                      optionItem.description !== String.fromCharCode(160) ? (
                        <div className='option-feedback'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: optionItem.description,
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            className='info-icon'
                          />
                        </div>
                      ) : null}
                    </div>
                  ) : optionItem && optionItem.type === 1 ? (
                    <div
                      key={`${question.id}-${optionIndex}`}
                      className='question-row'
                    >
                      <div className='col-xl-6 matching-options-wrapper'>
                        <div className='matching-options-container'>
                          <label htmlFor={optionItem.id}>
                            {optionItem.name}
                          </label>
                          {(() => {
                            const answer = question.options.find(
                              (item) => item.id === optionItem.selected
                            )

                            return answer ? (
                              <label htmlFor={optionItem.id}>
                                {answer.name}
                              </label>
                            ) : (
                              <label className='hint-text'>
                                {language.courses
                                  ? language.courses.no_option_selected
                                  : null}
                              </label>
                            )
                          })()}
                          {(() => {
                            const answer = question.options.find(
                              (item) => item.id === optionItem.selected
                            )

                            return optionItem.selected &&
                              optionItem.id === answer.match &&
                              optionItem.selected === answer.id ? (
                              <FontAwesomeIcon
                                icon={faCheck}
                                size='md'
                                className='icon-answ-correct'
                              />
                            ) : optionItem.selected ? (
                              <FontAwesomeIcon
                                icon={faTimes}
                                size='md'
                                className='icon-answ-incorrect'
                              />
                            ) : null
                          })()}
                        </div>
                      </div>
                    </div>
                  ) : null
                )
              })()}

              {question.type === 7 && <p>{question.answer}</p>}
              {question.type === 8 && (
                <GridQuestions
                  editMode={false}
                  viewMode={true}
                  tableData={question.tableData}
                />
              )}
            </Question>
          ))
        : null}
    </div>
  )
}

export default Submission
